var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFooterLinkedin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3 4.99134C3 4.41413 3.20271 3.93794 3.60811 3.56277C4.01351 3.18758 4.54055 3 5.18919 3C5.82626 3 6.34169 3.18469 6.73552 3.55411C7.14092 3.93506 7.34363 4.43145 7.34363 5.04329C7.34363 5.5974 7.14672 6.05915 6.7529 6.42857C6.3475 6.80952 5.81467 7 5.15444 7H5.13707C4.49999 7 3.98456 6.80952 3.59073 6.42857C3.19691 6.04762 3 5.56854 3 4.99134ZM3.22587 20.1429V8.57576H7.08301V20.1429H3.22587ZM9.22008 20.1429H13.0772V13.684C13.0772 13.2799 13.1236 12.9682 13.2162 12.7489C13.3784 12.3564 13.6245 12.0245 13.9546 11.7532C14.2847 11.482 14.6988 11.3463 15.1969 11.3463C16.4942 11.3463 17.1429 12.2179 17.1429 13.961V20.1429H21V13.5108C21 11.8023 20.5946 10.5065 19.7838 9.62337C18.973 8.74026 17.9015 8.2987 16.5695 8.2987C15.0753 8.2987 13.9112 8.93939 13.0772 10.2208V10.2554H13.0598L13.0772 10.2208V8.57576H9.22008C9.24324 8.94516 9.25483 10.0938 9.25483 12.0216C9.25483 13.9495 9.24324 16.6565 9.22008 20.1429Z",
    fill: "#204887"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFooterLinkedin);
export default __webpack_public_path__ + "static/media/Footer_linkedin.9ce6fe7647a89b49208f3b564b939a1c.svg";
export { ForwardRef as ReactComponent };